import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts";
import { FiTrendingUp } from "react-icons/fi";
import { useMemo } from "react";
import "../../containers/SpAndSuAnalysis/style.css";

// 🔹 Custom Tooltip Component
const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <div
                style={{
                    background: "white",
                    border: "1px solid #e2e8f0",
                    borderRadius: 8,
                    padding: "8px 12px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
            >
                <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
                <p style={{ margin: 0, color: "#475569" }}>
                    Bookings: <span style={{ fontWeight: 600 }}>{payload[0].value}</span>
                </p>
            </div>
        );
    }
    return null;
};

// 🔹 Custom Legend Component
const CustomLegend = () => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 10 }}>
        <div
            style={{
                width: 16,
                height: 4,
                borderRadius: 2,
                backgroundColor: "#667eea",
            }}
        />
        <span style={{ fontSize: 14, color: "#475569" }}>
            Bookings <span style={{ color: "#94a3b8" }}>(hover to see values)</span>
        </span>
    </div>
);

export const BookingChart = ({ data, title, color = "#667eea" }) => {
    const formattedData = useMemo(() => {
        if (!data?.labels || !data?.data) return [];
        return data.labels.map((label, i) => ({
            time: label,
            revenue: data.data[i] || 0,
        }));
    }, [data]);

    return (
        <div className="chart-card">
            <div className="chart-header">
                <div className="chart-header-left">
                    <FiTrendingUp className="chart-icon" size={20} />
                    <h3 className="chart-title">{title}</h3>
                </div>
            </div>

            <ResponsiveContainer width="100%" height={280}>
                <LineChart data={formattedData}>
                    <defs>
                        <linearGradient id={`gradient-${color}`} x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={color} stopOpacity={0.3} />
                            <stop offset="95%" stopColor={color} stopOpacity={0} />
                        </linearGradient>
                    </defs>

                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" opacity={0.5} />
                    <XAxis
                        dataKey="time"
                        stroke="#64748b"
                        fontSize={12}
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis
                        stroke="#64748b"
                        fontSize={12}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(value) => value}
                    />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend content={<CustomLegend />} />

                    <Line
                        type="monotone"
                        dataKey="revenue"
                        stroke={color}
                        strokeWidth={3}
                        dot={{ fill: color, strokeWidth: 2, r: 5 }}
                        activeDot={{ r: 7, fill: color }}
                        fill={`url(#gradient-${color})`}
                    />
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};
